export const color = [
  '#5470c6',
  '#91cc75',
  '#fac858',
  '#ee6666',
  '#73c0de',
  '#3ba272',
  '#fc8452',
  '#9a60b4',
  '#ea7ccc',
  '#999999',
  '#666666',
  '#333333',
  '#c6e579',
  '#ff6666',
  '#f7fb38',
  '#ffc0cb',
  '#3399ff',
  '#ffcc11',
  '#c2c2f0',
  '#ffb366',
  '#ff6600',
  '#66c2ff',
  '#814506',
  '#d9b3ff',
  '#66ff66',
  '#c2f0c2',
  '#b3e0ff',
  '#ff9999',
  '#FFF3B2',
  '#ccff99',
  '#08ffff',
  '#ff8080',
  '#c2c2c2',
  '#6699cc',
  '#2ad2de',
  '#ffcc80',
  '#0D6629',
  '#F3F740',
  '#aa5599',
  '#ffccff',
  '#66cccc',
  '#99ffcc',
  '#ff6698',
  '#ffcccc',
  '#669911',
  '#ff8800',
  '#1fb316',
  '#ffcc66',
  '#99f136',
  '#ccff77',
  '#b3d937',
  '#984567',
  '#401c99',
  '#CD7B71',
  '#A76217',
  '#b3b3cc',
  '#F7B8BC',
  '#290224',
  '#FEA095',
  '#4488dd',
  '#ccff33',
  '#f13300',
  '#ff00e0',
  '#49cc99',
  '#234567',
  '#cc7809',
  '#2003cc',
  '#22ffaa',
  '#FEFCA7',
  '#99b287',
  '#FF8500',
  '#b3b345',
  '#098761',
  '#7f0c99',
  '#cc1357',
  '#206C6C',
  '#F6F7CB',
  '#1111f0',
  '#900988',
  '#040902',
  '#ff5567',
  '#ccddbb',
  '#f0bd06',
  '#ff1279',
  '#f60c39',
  '#34c112',
  '#cc2468',
  '#111101',
  '#ff2299',
  '#ff0009',
  '#99ff99',
  '#ccdd88',
  '#b35609',
  '#99ccff',
  '#f71c49',
  '#cc1480',
  '#ffc2b3',
  '#b387cc',
  '#4567f0',
  '#110901',
  '#201123',
  '#ff0056',
  '#ccdd44',
  '#6fb856',
  '#ff0123'
]
